import { getAppStore } from '../../app/AppStore';
import { selectContentFromAppState } from '../../app/selectors/ContentSelectors';
import { toQPromise } from '../../commonInfra/utils/QUtils';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IExplorableItemTypeInfo } from '../../ts/models/resourceInfoParts';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { BackgroundJobAllowedActions } from './BackgroundJobAllowedActions';
import { BackgroundJobStatus, BackgroundJobTaskType } from './BackgroundJobInfo';
import { CancelBackgroundJobRequest, ICancelBackgroundJobParams } from './CancelBackgroundJobRequest';
import { GetBackgroundJobsRequest, IGetBackgroundJobsResult } from './GetBackgroundJobsRequest';
import { IBackgroundJob } from './IBackgroundJob';

export interface IBackgroundJobInfo extends IBackgroundJob, IExplorableItemTypeInfo<'backgroundJob'> {
}

export namespace BackgroundJobsService {
  export const backgroundJobsResponseMapper = (result: IGetBackgroundJobsResult): IBackgroundJobInfo[] =>
    result.backgroundJobs.map((j: IBackgroundJob) => {
      return {
        ...j,
        contentType: 'backgroundJob',
        id: j.jobId + '',
      } as IBackgroundJobInfo; // Typescript can't infer whether 'backgroundJobs' is a string or 'backgroundJobs'
  });
  export function all(): ResourceQuery<IBackgroundJobInfo> {
    const fetcher = new WebClientListResourceFetcher(GetBackgroundJobsRequest, backgroundJobsResponseMapper);
    return new ResourceQuery(fetcher);
  }

  export function actions(id: string): ng.IPromise<BackgroundJobAllowedActions> {
    const items = selectContentFromAppState(getAppStore().getState());
    const backgroundJob: IBackgroundJobInfo | undefined = items.find((item: IBackgroundJobInfo) => item.jobId + '' === id) as IBackgroundJobInfo;
    if (!backgroundJob) {
      throw new Error('Failed to find background job with id ' + backgroundJob.jobId);
    }
    const incomplete = backgroundJob.status === BackgroundJobStatus.Pending || backgroundJob.status === BackgroundJobStatus.InProgress;
    const isSystemJob = backgroundJob.taskType === BackgroundJobTaskType.System;
    const cancelBackgroundJob = incomplete && !isSystemJob;
    return toQPromise(Promise.resolve({ cancelBackgroundJob }));
  }

  export function cancelBackgroundJob(cancelParms: ICancelBackgroundJobParams): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new CancelBackgroundJobRequest(cancelParms));
  }
}
